import { MButton, TMButtonProps } from "src/ui/Button/MButton"

export function TextButton({ children, ...props }: TMButtonProps) {
  return (
    <MButton {...props} variant="minimal">
      {children}
    </MButton>
  )
}
